import currentUserData from 'javascripts/consumer/models/current_user_data';

$(() => {
  if (typeof braze !== 'undefined') {
    // optionally show all in-app messages without custom handling
    braze.automaticallyShowInAppMessages();

    // if you use Content Cards
    braze.subscribeToContentCardsUpdates((cards) => {
      // cards have been updated
    });

    // optionally set the current user's external ID before starting a new session
    // you can also call `changeUser` later in the session after the user logs in
    if (currentUserData) {
      braze.changeUser(currentUserData.id);
    }

    // `openSession` should be called last - after `changeUser` and `automaticallyShowInAppMessages`
    braze.openSession();
  }
});
